import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
if (typeof document !== 'undefined') {
  const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/jbnWXFE7WM5N12A9oKvrTY/Texto_del_parrafo_(4).webp';
  if (!document.querySelector('link[rel="preconnect"][href="https://cdn.magicpatterns.com"]')) {
    const pc = document.createElement('link');
    pc.rel = 'preconnect';
    pc.href = 'https://cdn.magicpatterns.com';
    document.head.insertBefore(pc, document.head.firstChild);
  }
  // Preconnect to Google Fonts so the font CSS + font files start downloading
  // as early as possible (improves FCP / LCP).
  const fontOrigins: Array<[string, boolean]> = [['https://fonts.googleapis.com', false], ['https://fonts.gstatic.com', true]];
  fontOrigins.forEach(([href, crossorigin]) => {
    if (!document.querySelector(`link[rel="preconnect"][href="${href}"]`)) {
      const fp = document.createElement('link');
      fp.rel = 'preconnect';
      fp.href = href;
      if (crossorigin) fp.crossOrigin = 'anonymous';
      document.head.insertBefore(fp, document.head.firstChild);
    }
  });
  if (!document.querySelector(`link[rel="preload"][href="${MOCKUP_IMAGE}"]`)) {
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = MOCKUP_IMAGE;
    (preload as any).fetchPriority = 'high';
    document.head.insertBefore(preload, document.head.firstChild);
  }
}
render(<App data-id="element-515" />, document.getElementById('root'));